export const actions = {
  async trackEvent(context, { eventName, eventPayload }) {
    const { id: clientId } = this.$auth.user

    try {
      await this.$axios.post(
        `${process.env.IMPORTSCAN_AWS_URL}/clients/${clientId}/zoho/events`,
        {
          eventName,
          eventPayload
        }
      )
    } catch (error) {
      if (this.$axios.isCancel(error)) return
    }
  },
  async trackGenAISubmission({ dispatch }, { companies }) {
    if (companies.length === 0) return

    // Call the trackEvent action to track GenAI submission events
    const eventName = companies.length > 1 ? 'genai_bulk' : 'genai_individual'
    const eventPayload = {
      company_count: companies.length,
      companies
    }

    await dispatch('trackEvent', {
      eventName,
      eventPayload
    })
  }
}
